import MenuHeader from './MenuHeader';
import MenuContent from './MenuContent';
import { MenuItems } from '../types';
import BackToGame from './BackToGame';
import { useLocation } from 'react-router-dom';
import { classNames } from '../../../../../helper/classNames';

type MenuSheetProps = {
  className?: string;
  isOpen: boolean;
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  items: MenuItems;
  numPlayers: number;
};

function MenuSheet({
  className,
  isOpen,
  onClose,
  items,
  numPlayers,
}: MenuSheetProps) {
  const currentGameId = sessionStorage.getItem('currentGameId');
  const location = useLocation();
  const isGamePage = location.pathname.includes('game');

  return (
    <div
      className={classNames(
        'transition-w ease-in-out duration-300 absolute h-full bg-white top-0 right-0 text-black text-left text-nowrap overflow-hidden max-w-80',
        isOpen ? 'w-3/5' : 'w-0',
        className
      )}
    >
      <MenuHeader onClose={onClose} />
      {currentGameId && !isGamePage && numPlayers !== 0 && (
        <BackToGame currentGameId={currentGameId} />
      )}
      <MenuContent items={items} numPlayers={numPlayers} />
      <p className="p-3 text-gray-500">Version {__APP_VERSION__}</p>
    </div>
  );
}

export default MenuSheet;
